import http from './http';

const httpPost = async (url, data = undefined, config = undefined) => {
  const response = await http.post(url, data, config);
  return response.data;
};

export default httpPost;
